import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { NonDatasourceFieldIconFragmentGql } from './NonDatasourceFieldIconFragmentGql';

export const FieldIconFragmentGql: DocumentNode = gql`
fragment FieldIconFragment on Field {
  ...NonDatasourceFieldIconFragment
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      ...NonDatasourceFieldIconFragment
    }
  }
}
${NonDatasourceFieldIconFragmentGql}
`;
